import React, { useState, useEffect } from 'react'
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, Button, Typography, MenuItem, FormControl, Select, InputLabel, FormHelperText, CircularProgress, Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import upload from '../../Admin/assets/images/upload-category.svg';
import Image from '../../Utils/getImage';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Adddesign = ({ openDialog, setOpenDialog, edit, setEdit, selectedDesign, setgetdesign, mode, selectedSubDesign, setgetdesignsub }) => {
  const title = mode === "Design Type" ? "Add your Design type to the list" : "Add your Design type to the list";
  const [responseloading, setResponseLoading] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategory, setsubCategory] = useState([]);
  const [designtype, setDesigntype] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbar1, setOpenSnackbar1] = useState(false);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [localToDelete, setLocalToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [existingImages, setExistingImages] = useState([]);
  const image = selectedDesign?.Bannerimage || [];


  const handleClose = () => {
    setOpenDialog(false);
    setEdit(false);
    if (edit && selectedDesign) {
      // Set form data for edit
      setFormData({
        category: selectedDesign?.category || "",
        subCategory: selectedDesign?.subCategory || "",
        design_type: selectedDesign?.designtype || "",
        status: selectedDesign?.status === true ? "true" : "false",
        picture: [],
      });
      setImagePreview('')
      setErrors({
        category: "",
        subCategory: "",
        design_type: "",
        status: "",
        picture: [],
      });
    } else {
      setFormData({
        category: "",
        subCategory: "",
        design_type: "",
        status: "",
        picture: [],
      });
      setImagePreview('')
      setErrors({
        category: "",
        subCategory: "",
        design_type: "",
        status: "",
        picture: [],
      });
    }

    if (edit && selectedSubDesign) {
      setSubmData({
        category: selectedSubDesign?.category || "",
        subCategory: selectedSubDesign?.subCategory || "",
        design_type: selectedSubDesign?.designtype || "",
        name: selectedSubDesign?.name || "",
        description: selectedSubDesign?.description || "",
        status: selectedSubDesign?.status === true ? "true" : "false",
        picture: [],
      });
      setErrorssub({
        category: "",
        subCategory: "",
        design_type: "",
        // design_sub_type: "",
        status: "",
        price: "",
        picture: [],
      });
      setsubImagePreview([]);
      setLocalPreview([]);
    } else {
      setSubmData({
        category: "",
        subCategory: "",
        design_type: "",
        // design_sub_type: "",
        status: "",
        picture: [],
      });
      setErrorssub({
        category: "",
        subCategory: "",
        design_type: "",
        // design_sub_type: "",
        status: "",
        price: "",
        picture: [],
      });
      setsubImagePreview([]);
      setLocalPreview([]);
    }
  }

  const [errors, setErrors] = useState({
    category: "",
    subCategory: "",
    design_type: "",
    status: "",
    picture: "",
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // status validation
    if (formData.status.trim() === "") {
      newErrors.status = "Status is required";
      isValid = false;
    }

    // category validation
    if (formData.category.trim() === "") {
      newErrors.category = "Category is required";
      isValid = false;
    }

    // subCategory validation
    if (formData.subCategory.trim() === "") {
      newErrors.subCategory = "SubCategory is required";
      isValid = false;
    }

    //design_type validation
    if (formData.design_type.trim() === "") {
      newErrors.design_type = "Design Type is required";
      isValid = false;
    }

    // picture validation
    if (!edit && !formData.picture.length) {
      newErrors.picture = "Picture is required";
      isValid = false;
    }

    // Update the errors state
    setErrors(newErrors);

    return isValid;
  };

  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    design_type: "",
    status: "",
    picture: [],
  });
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    fetchCategory();
    console.log("selectedDesign------", selectedDesign)
    if (edit && selectedDesign) {
      setFormData({
        category: selectedDesign?.category || "",
        subCategory: selectedDesign?.subCategory || "",
        design_type: selectedDesign?.designtype || "",
        status: selectedDesign?.status === true ? "true" : "false",
        picture: [],
      });

      (async () => {
        const options = await fetchsubCategory(selectedDesign.category);

        const exists = Array.isArray(options) &&
          options.some(x => x.subcategoryId === selectedDesign?.subCategory);


        if (exists) {
          setFormData((prev) => ({
            ...prev,
            subCategory: selectedDesign.subCategory,
          }));
        }
      })();

      if (selectedDesign?.Bannerimage) {
        setImagePreview(image);
      } else {
        setImagePreview(null);
      }

    } else {
      setFormData({
        category: "",
        subCategory: "",
        design_type: "",
        status: "",
        picture: [],
      });
      setImagePreview('')
    }
  }, [edit && selectedDesign]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "category") {
      fetchsubCategory(value);
      setFormData((prev) => ({ ...prev, subCategory: "" }));
    }
  };


  const handleFileChangedesign = (e) => {
    const files = Array.from(e.target.files);

    setFormData((prev) => ({
      ...prev,
      picture: files,
    }));
    setErrors((prev) => ({
      ...prev,
      picture: "",
    }));

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreview(previews);
  };

  const handleDesigntype = async () => {
    if (!validateForm()) {
      return;
    }
    setResponseLoading(true)
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (Array.isArray(value) && key === "picture") {
          value.forEach((file) => {
            data.append(key, file);
          });
        } else {
          data.append(key, value);
        }
      });
      const response = await instance.post('/Catalogue/addDesignType', data)

      if (response.data.success === true) {
        toast.success(response.data.message)
        handleClose();
        setgetdesign(true)
      } else {
        toast.error(response.data.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    } finally {
      setResponseLoading(false)
    }
  }

  const handleUpdateDesigntype = async () => {
    if (!validateForm()) {
      return;
    }
    setResponseLoading(true)
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (Array.isArray(value) && key === "picture") {
          value.forEach((file) => {
            data.append(key, file);
          });
        } else {
          data.append(key, value);
        }
      });

      const response = await instance.put(`/Catalogue/updateDesignType?_id=${selectedDesign.designId}`, data)
      if (response.data.success === true) {
        toast.success(response.data.message)
        handleClose();
        setgetdesign(true)
      } else {
        toast.error(response.data.message)
      }
    }
    catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setResponseLoading(false)
    }
  }








  //designs
  const [errorssub, setErrorssub] = useState({
    category: "",
    subCategory: "",
    design_type: "",
    name: "",
    description: "",
    status: "",
    price: "",
    picture: null,
  });

  const validateFormsub = () => {
    let isValid = true;
    const newErrors = {};

    // category validation
    if (!subData.category || subData.category.trim() === "") {
      newErrors.category = "Category is required";
      isValid = false;
    }

    // subCategory validation
    if (!subData.subCategory || subData.subCategory.trim() === "") {
      newErrors.subCategory = "SubCategory is required";
      isValid = false;
    }

    // design_type validation
    if (!subData.design_type || subData.design_type.trim() === "") {
      newErrors.design_type = "Design type is required";
      isValid = false;
    }

    // name validation
    if (!subData.name || subData.name.trim() === "") {
      newErrors.name = "Name is required";
      isValid = false;
    }

    // description validation
    if (!subData.description || subData.description.trim() === "") {
      newErrors.description = "Description is required";
      isValid = false;
    }

    // status validation
    if (!subData.status || subData.status.trim() === "") {
      newErrors.status = "Status is required";
      isValid = false;
    }

    // picture validation
    if (!edit && (!subData.picture || subData.picture.length === 0)) {
      newErrors.picture = "Picture is required";
      isValid = false;
    }
    // price validation
    if (!edit && !subData.price || subData.price.length === 0) {
      newErrors.price = "price is required";
      isValid = false;
    }

    // Update the errors state
    setErrorssub(newErrors);

    return isValid;
  };

  const [subData, setSubmData] = useState({
    category: "",
    subCategory: "",
    design_type: "",
    name: "",
    description: "",
    status: "",
    price: "",
    picture: [],
  });
  const [subimagePreview, setsubImagePreview] = useState(null);
  const [localPreview, setLocalPreview] = useState(null);

useEffect(() => {
  if (edit && selectedSubDesign) {
    // Set all fields EXCEPT subCategory (we will set after API)
    setSubmData({
      category: selectedSubDesign?.category || "",
      subCategory: "",  // important: set blank now
      design_type: selectedSubDesign?.designtype || "",
      name: selectedSubDesign?.name || "",
      description: selectedSubDesign?.description || "",
      status: selectedSubDesign?.status ? "true" : "false",
      price: selectedSubDesign?.price || "",
      picture: [],
    });

    // ⭐ Load subcategories from API for this category
    (async () => {
      const response = await instance.get(
        `/Catalogue/getSubCategory?category=${selectedSubDesign.category}`
      );

      const formatted = response?.data?.data?.map((sub, index) => ({
        sno: index + 1,
        subCategory: sub?.subCategory,
        subcategoryId: sub?._id,
      })) || [];

      setsubCategory(formatted);

      // ⭐ Now set correct subCategory (after loading options)
      const exists = formatted.some(
        (s) => s.subcategoryId === selectedSubDesign.subCategory
      );

      if (exists) {
        setSubmData((prev) => ({
          ...prev,
          subCategory: selectedSubDesign.subCategory,
        }));
      }
    })();

    // Image handling
    if (selectedSubDesign?.Bannerimage) {
      setsubImagePreview(selectedSubDesign.Bannerimage);
      setExistingImages(selectedSubDesign.Bannerimage);
    } else {
      setsubImagePreview([]);
      setLocalPreview([]);
      setExistingImages([]);
    }
  } else {
    // Reset for Add mode
    setSubmData({
      category: "",
      subCategory: "",
      design_type: "",
      name: "",
      description: "",
      status: "",
      picture: [],
    });
    setsubImagePreview([]);
    setLocalPreview([]);
  }
}, [edit, selectedSubDesign]);



  const handlesubInputChange = (e) => {
    const { name, value } = e.target;
    setSubmData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    setErrorssub((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "category" && value) {
      fetchsubCategory(value);
      // Reset subCategory when category changes
      setSubmData((prev) => ({
        ...prev,
        subCategory: "",
        design_type: ""
      }));

    }
    if (name === "subCategory") {
      setSubmData((prev) => ({ ...prev, design_type: "" }));
    }

  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    // Append new files to existing picture array
    setSubmData((prev) => ({
      ...prev,
      picture: [...prev.picture, ...files], // append instead of replace
    }));

    setErrorssub((prev) => ({
      ...prev,
      picture: "",
    }));

    // Append new previews to existing preview
    const previews = files.map((file) => URL.createObjectURL(file));
    setLocalPreview((prev) => [...(prev || []), ...previews]);
  };


  const handleDesignSub = async () => {
    if (!validateFormsub()) {
      return;
    }
    setResponseLoading(true)
    try {
      const data = new FormData();
      Object.entries(subData).forEach(([key, value]) => {
        if (Array.isArray(value) && key === "picture") {
          value.forEach((file) => {
            data.append(key, file);
          });
        } else {
          data.append(key, value);
        }
      });

      const response = await instance.post('/Catalogue/addDesign', data)
      if (response.data.success === true) {
        toast.success(response.data.message)
        handleClose();
        setgetdesignsub(true)
      } else {
        toast.error(response.data.message)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    } finally {
      setResponseLoading(false)
    }
  }

  const handleUpdateDesignSub = async () => {
    if (!validateFormsub()) return;

    setResponseLoading(true);

    try {
      const data = new FormData();

      // Append only new images
      subData.picture.forEach((file) => {
        data.append("picture", file);
      });

      // Append other fields
      data.append("category", subData.category);
      data.append("subCategory", subData.subCategory);
      data.append("design_type", subData.design_type);
      data.append("name", subData.name);
      data.append("description", subData.description);
      data.append("status", subData.status);
      data.append("price", subData.price);

      // Append only remaining existing images
      existingImages.forEach((img) => data.append("existingImages", img));

      const response = await instance.put(
        `/Catalogue/updateDesign?_id=${selectedSubDesign.designsubId}`,
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        handleClose();
        setgetdesignsub(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setResponseLoading(false);
    }
  };

  const handleDeleteImage = async () => {
    if (imageToDelete === null) return;

    const imageURL = subimagePreview[imageToDelete];
    // console.log("imageToDelete", imageToDelete);

    if (existingImages.includes(imageURL)) {
      // Delete from server
      const payload = {
        design_id: selectedSubDesign?.designsubId,
        filename: imageURL,
      };

      try {
        setDeleting(true);
        const response = await instance.delete("/Catalogue/deleteImage", { data: payload });
        if (response.data?.success === true) {
          toast.success(response.data.message || "Image deleted successfully.");
          setExistingImages((prev) => prev.filter((img) => img !== imageURL));
          setsubImagePreview((prev) => prev.filter((_, i) => i !== imageToDelete));
          setImageToDelete(null);
        } else {
          toast.error(response.data?.message || "Failed to delete image.");
        }
      } catch (error) {
        console.error("Error deleting image:", error);
      } finally {
        setDeleting(false);
        setOpenSnackbar(false);
      }
    } else {
      // Remove new image from subData.picture
      setSubmData((prev) => ({
        ...prev,
        picture: prev.picture.filter((file) => URL.createObjectURL(file) !== imageURL),
      }));


      setsubImagePreview((prev) => prev.filter((_, i) => i !== imageToDelete));
      setImageToDelete(null);
      setOpenSnackbar(false);
    }
  };

  const handleDeleteLocalImage = async () => {
    if (localPreview === null) return;

    // Remove new image from subData.picture
    setSubmData((prev) => ({
      ...prev,
      picture: prev.picture.filter((_, index) => index !== localToDelete),
    }));
    // console.log("subData", subData);

    setLocalPreview((prev) => prev.filter((_, i) => i !== localToDelete));
    setLocalToDelete(null);
    setOpenSnackbar1(false);
  };

  //category
  const fetchCategory = async () => {
    try {
      const response = await instance.get('/Catalogue/getCategorys')
      const formatteddata = response?.data?.data?.map((cate, index) => ({
        sno: index + 1,
        category: cate?.category,
        categoryId: cate?._id,
      }))

      setCategory(formatteddata);
    }
    catch (error) {
      console.log("error to fetch category:", error.message)
    }

  }

  //fetch SubCategory
  const fetchsubCategory = async (categoryId) => {
    try {
      if (!categoryId) {
        setsubCategory([]);
        return;
      }
      const response = await instance.get(
        `/Catalogue/getSubCategory?category=${categoryId}`
      );
      const formatteddata = response?.data?.data?.map((subcategory, index) => ({
        sno: index + 1,
        subCategory: subcategory?.subCategory,
        subcategoryId: subcategory?._id,
      }))

      setsubCategory(formatteddata || []);
    }
    catch (error) {
      console.log("error to fetch subcategory:", error.message);
      setsubCategory([]);
    }

  }
  useEffect(() => {
    fetchCategory();

    fetchsubCategory();
  }, []);

  //designtype
  const fetchDesignTypes = async (categoryId, subCategoryId) => {
    try {
      if (!categoryId || !subCategoryId) {
        setDesigntype([]);
        return;
      }

      const response = await instance.get(`/Catalogue/getDesignType?category=${categoryId}&subCategory=${subCategoryId}`)
      const formatteddata = response?.data?.data?.map((design, index) => ({
        sno: index + 1,
        designtype: design?.design_type,
        designId: design?._id,
      }))

      setDesigntype(formatteddata || []);

    }
    catch (error) {
      console.log("error to fetch Designs:", error.message);
      setDesigntype([]);
    }
  }

  useEffect(() => {
    if (subData.category && subData.subCategory) {
      fetchDesignTypes(subData.category, subData.subCategory);
    } else {
      setDesigntype([]);
    }
  }, [subData.category, subData.subCategory]);

  console.log("subCategory--------", subCategory)
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openDialog}
        className="admin-admins"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {edit ? `Edit ${mode}` : `Add ${mode}`}
          <Typography>{title}</Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {mode === 'Design Type' ?
            (
              <section className="add-admin">
                <Grid container spacing={3}>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="category-label">Select Category</InputLabel>
                        <Select
                          labelId="category-label"
                          value={formData.category}
                          onChange={handleInputChange}
                          label="Select Category"
                          name="category"
                          required
                        >
                          {category.map((cate) => (
                            <MenuItem key={cate.categoryId} value={cate.categoryId}>
                              {cate.category}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={!!errors.category}>
                          {errors.category}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="subcategory-label">Select subCategory</InputLabel>
                        <Select
                          labelId="subcategory-label"
                          value={formData.subCategory}
                          onChange={handleInputChange}
                          label="Select subCategory"
                          name="subCategory"
                          required
                          disabled={!formData.category}
                        >
                          {subCategory.map((subCate) => (
                            <MenuItem key={subCate.subcategoryId} value={subCate.subcategoryId}>
                              {subCate.subCategory}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={!!errors.subCategory}>
                          {errors.subCategory}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        placeholder="Enter design type"
                        label="design type"
                        type="text"
                        fullWidth
                        required
                        size="small"
                        name="design_type"
                        value={formData.design_type}
                        onChange={handleInputChange}
                      />
                      <FormHelperText error={!!errors.design_type}>
                        {errors.design_type}
                      </FormHelperText>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className='admin-textfiled'>
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Select Status"
                          required
                          placeholder="Select Status"
                          fullWidth
                          name="status"
                          value={formData.status}
                          onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: "status",
                                value: e.target.value,
                              },
                            })
                          }
                          disabled={edit}
                        >
                          <MenuItem value="true">Active</MenuItem>
                          <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                        <FormHelperText error={!!errors.status}>
                          {errors.status}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    <div className='upload-image-preview'>
                      <div className='file-upload-image'>
                        <Typography variant='h5'>Design Type image upload *</Typography>
                        <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                          <img src={upload} alt="upload" />
                        </label>
                        <input
                          id="file-upload"
                          type="file"
                          name="picture"
                          accept="image/*"
                          onChange={handleFileChangedesign}
                          style={{ display: "none" }}
                        />
                        <FormHelperText error={!!errors.picture}>
                          {errors.picture}
                        </FormHelperText>
                      </div>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    {imagePreview && (
                      <div className="categoryimage-preview">
                        <ul style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: 0 }}>
                          <li style={{ position: "relative", listStyle: "none" }}>
                            {typeof imagePreview === "string" && !imagePreview.startsWith("blob:") ? (
                              <Image
                                src={imagePreview}
                                alt="Design Upload"
                                width={150}
                                height={150}
                                className="rounded-md"
                              />
                            ) : (
                              <img
                                src={imagePreview}
                                alt="Design Upload"
                                width={150}
                                height={150}
                                className="rounded-md"
                              />
                            )}

                            {/* Cancel / Remove button */}
                            <IconButton
                              onClick={() => setImagePreview(null)}
                              sx={{
                                position: "absolute",
                                top: -8,
                                right: -8,
                                backgroundColor: "white",
                                padding: "12px",
                                borderRadius: "50%",
                                boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                color: "#ff0000",
                                width: "20px",
                                height: "20px"
                              }}
                            >
                              <CloseIcon width="08px" height="08px" />
                            </IconButton>

                          </li>
                        </ul>
                      </div>
                    )}
                  </Grid>

                </Grid>
              </section>
            ) : (
              <section className="add-admin">
                <Grid container spacing={3}>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        placeholder="Enter Name"
                        label="Name"
                        type="text"
                        fullWidth
                        required
                        size="small"
                        name="name"
                        value={subData.name}
                        onChange={handlesubInputChange}
                      />
                      <FormHelperText error={!!errorssub.name}>
                        {errorssub.name}
                      </FormHelperText>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        placeholder="Enter Price"
                        label="Price"
                        type="text"
                        fullWidth
                        required
                        size="small"
                        name="price"
                        value={subData.price}
                        onChange={handlesubInputChange}
                      />
                      <FormHelperText error={!!errorssub.price}>
                        {errorssub.price}
                      </FormHelperText>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        placeholder="Enter Description"
                        label="Description"
                        type="text"
                        fullWidth
                        required
                        size="small"
                        name="description"
                        value={subData.description}
                        onChange={handlesubInputChange}
                      />
                      <FormHelperText error={!!errorssub.description}>
                        {errorssub.description}
                      </FormHelperText>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="category-label">Select Category</InputLabel>
                        <Select
                          labelId="category-label"
                          value={subData.category}
                          onChange={handlesubInputChange}
                          label="Select Category"
                          name="category"
                          required
                        >
                          {category.length > 0 ? (
                            category.map((cate) => (
                              <MenuItem key={cate.categoryId} value={cate.categoryId}>
                                {cate.category}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No Categories available</MenuItem>
                          )}
                        </Select>
                        <FormHelperText error={!!errorssub.category}>
                          {errorssub.category}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="subcategory-label">Select subCategory</InputLabel>
                        <Select
                          labelId="subcategory-label"
                          value={subData.subCategory}
                          onChange={handlesubInputChange}
                          label="Select subCategory"
                          name="subCategory"
                          required
                          disabled={!subData.category}
                        >
                          {subCategory.length > 0 ? (
                            subCategory.map((subCate) => (
                              <MenuItem key={subCate.subcategoryId} value={subCate.subcategoryId}>
                                {subCate.subCategory}
                              </MenuItem>
                            ))) : (
                            <MenuItem disabled>No subCategories available</MenuItem>
                          )}
                        </Select>
                        <FormHelperText error={!!errorssub.subCategory}>
                          {errorssub.subCategory}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="design-type-label">Select Design Type</InputLabel>
                        <Select
                          labelId="designtype-label"
                          label="Select Design Type"
                          name="design_type"
                          placeholder="Enter Design type"
                          value={subData.design_type}
                          onChange={handlesubInputChange}
                          disabled={!subData?.category || !subData?.subCategory}
                          required
                        >
                          {designtype.length > 0 ? (
                            designtype.map((design) => (
                              <MenuItem key={design.designId} value={design.designId}>
                                {design.designtype}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No design types available</MenuItem>
                          )}
                        </Select>
                        <FormHelperText error={!!errorssub.design_type}>
                          {errorssub.design_type}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                    <div className='admin-textfiled'>
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Select Status"
                          required
                          placeholder="Select Status"
                          fullWidth
                          name="status"
                          value={subData.status}
                          onChange={(e) =>
                            handlesubInputChange({
                              target: {
                                name: "status",
                                value: e.target.value,
                              },
                            })
                          }
                          disabled={edit}
                        >
                          <MenuItem value="true">Active</MenuItem>
                          <MenuItem value="false">Inactive</MenuItem>
                        </Select>
                        <FormHelperText error={!!errorssub.status}>
                          {errorssub.status}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                    <div className='upload-image-preview'>
                      <div className='file-upload-image'>
                        <Typography variant='h5'>Design image upload *</Typography>
                        <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                          <img src={upload} alt="upload" />
                        </label>
                        <input
                          id="file-upload"
                          type="file"
                          accept="image/*"
                          name="picture"
                          multiple
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <FormHelperText error={!!errorssub.picture}>
                          {errorssub.picture}
                        </FormHelperText>
                      </div>
                    </div>
                  </Grid>
                  {subimagePreview?.length > 0 || localPreview?.length > 0 ? (
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                      <div className="categoryimage-preview">

                        {/* Existing Images */}
                        {subimagePreview?.length > 0 && (
                          <ul style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: 0 }}>
                            {subimagePreview.map((img, index) => (
                              <li key={index} style={{ position: "relative", listStyle: "none" }}>
                                {typeof img === "string" && !img.startsWith("blob:") ? (
                                  <Image
                                    src={img}
                                    alt={`Sub Design ${index}`}
                                    width={150}
                                    height={150}
                                    className="rounded-md"
                                  />
                                ) : (
                                  <img
                                    src={img}
                                    alt={`Sub Design ${index}`}
                                    width={150}
                                    height={150}
                                    className="rounded-md"
                                  />
                                )}

                                <IconButton
                                  onClick={() => {
                                    setImageToDelete(index);
                                    setOpenSnackbar(true);
                                  }}
                                  sx={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    backgroundColor: "white",
                                    padding: "12px",
                                    borderRadius: "50%",
                                    boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                    color: "#ff0000",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                >
                                  <CloseIcon width="08px" height="08px" />
                                </IconButton>
                              </li>
                            ))}
                          </ul>
                        )}

                        {/* Local New Images */}
                        {localPreview?.length > 0 && (
                          <ul style={{ display: "flex", flexWrap: "wrap", gap: "10px", padding: 0 }}>
                            {localPreview.map((img, index) => (
                              <li key={index} style={{ position: "relative", listStyle: "none" }}>
                                <img
                                  src={img}
                                  alt={`Sub Design ${index}`}
                                  width={150}
                                  height={150}
                                  className="rounded-md"
                                />

                                <IconButton
                                  onClick={() => {
                                    setLocalToDelete(index);
                                    setOpenSnackbar1(true);
                                  }}
                                  sx={{
                                    position: "absolute",
                                    top: -8,
                                    right: -8,
                                    backgroundColor: "white",
                                    padding: "12px",
                                    borderRadius: "50%",
                                    boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                    color: "#ff0000",
                                    width: "20px",
                                    height: "20px",
                                  }}
                                >
                                  <CloseIcon width="08px" height="08px" />
                                </IconButton>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </Grid>
                  ) : null}

                </Grid>
              </section>
            )
          }
        </DialogContent>
        <DialogActions>
          {mode === 'Design Type' ?
            (
              <>
                <Button className="cancel-btn" onClick={handleClose}>
                  Cancel
                </Button>

                <Button className="add-btn" onClick={edit ? handleUpdateDesigntype : handleDesigntype}>
                  {responseloading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : edit ? 'Update' : 'Add'}
                </Button>
              </>
            ) : (
              <>
                <Button className="cancel-btn" onClick={handleClose}>
                  Cancel
                </Button>

                <Button className="add-btn" onClick={edit ? handleUpdateDesignSub : handleDesignSub}>
                  {responseloading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : edit ? 'Update' : 'Add'}
                </Button>
              </>
            )
          }
        </DialogActions>
      </BootstrapDialog>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          severity="warning"
          sx={{ backgroundColor: "#fff", color: "#333", boxShadow: 3 }}
          action={
            <>
              <Button
                color="error"
                size="small"
                disabled={deleting}
                onClick={handleDeleteImage}
              >
                {deleting ? "Deleting..." : "Yes"}
              </Button>
              <Button
                color="inherit"
                size="small"
                onClick={() => setOpenSnackbar(false)}
              >
                No
              </Button>
            </>
          }
        >
          Are you sure you want to remove this image?
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSnackbar1}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setOpenSnackbar1(false)}
      >
        <Alert
          severity="warning"
          sx={{ backgroundColor: "#fff", color: "#333", boxShadow: 3 }}
          action={
            <>
              <Button
                color="error"
                size="small"
                disabled={deleting}
                onClick={handleDeleteLocalImage}
              >
                {deleting ? "Deleting..." : "Yes"}
              </Button>
              <Button
                color="inherit"
                size="small"
                onClick={() => setOpenSnackbar1(false)}
              >
                No
              </Button>
            </>
          }
        >
          Are you sure you want to remove this image?
        </Alert>
      </Snackbar>
    </React.Fragment >
  )
}

export default Adddesign